export default "__VITE_ASSET__yqpvZ8TN__"